module.exports = __webpack_public_path__ + "img/ico-active-cam.bc93ae19.svg";